import { parseIsoDate } from "./date.ts";
import { DomainError, type IsoDate, type Operation, type RepeatRule } from "./model.ts";
import { assertRepeatRule, assertRuleCapacity } from "./repeat.ts";
import { upsertSchedulePhase } from "./schedule.ts";

export interface RuleEdit {
  readonly id: string;
  readonly effectiveFrom: IsoDate;
  readonly rule: RepeatRule;
}

/**
 * Adds a rule version without mutating the operation. A trusted present date prevents a
 * normal settings edit from silently changing a historical score.
 */
export function applyEffectiveRuleEdit(operation: Operation, edit: RuleEdit, trustedToday: IsoDate): Operation {
  parseIsoDate(trustedToday);
  parseIsoDate(edit.effectiveFrom);
  assertRepeatRule(edit.rule);
  assertRuleCapacity(edit.rule, edit.effectiveFrom);
  if (edit.effectiveFrom < trustedToday) {
    throw new DomainError("RETROACTIVE_RULE_EDIT", "repeat-rule edits must be effective today or later");
  }
  const sameDate = operation.ruleVersions.find((version) => version.effectiveFrom === edit.effectiveFrom);
  if (!sameDate && operation.ruleVersions.some((version) => version.id === edit.id)) {
    throw new DomainError("DUPLICATE_RULE_VERSION", `rule version id ${edit.id} already exists`);
  }
  return upsertSchedulePhase(operation, edit);
}
